import React from "react";

import { Menu } from "antd";
import { Link } from "react-router-dom";
import { useAuth } from "context/providers/auth";
import useGet from "hooks/useGet";

const getItems = (is_admin, pending_invitations_count) =>
  [
    {
      label: <Link to="/workers">Pracownicy</Link>,
      key: "workers",
    },
    is_admin && {
      label: <Link to="/users">Administratorzy</Link>,
      key: "users",
    },
    {
      label: (
        <Link to="/worker_invitations">
          {pending_invitations_count > 0 ? (
            <strong>Zaproszenia ({pending_invitations_count})</strong>
          ) : (
            "Zaproszenia"
          )}
        </Link>
      ),
      key: "worker_invitations",
    },
    {
      label: <Link to="/devices">Urządzenia</Link>,
      key: "devices",
    },
  ].filter(Boolean);

const WorkerTabs = ({ current }) => {
  const {
    state: { is_admin },
  } = useAuth();

  const { data } = useGet({
    query: ["pending_invitations_count"],
    path: "/worker_invitations/pending_count",
  });

  const pending_invitations_count = data?.count || 0;

  const items = getItems(is_admin, pending_invitations_count);

  return (
    <Menu
      selectedKeys={[current]}
      mode="horizontal"
      items={items}
      style={{ marginBottom: 20, justifyContent: "center" }}
    />
  );
};

export default WorkerTabs;
